var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7815_6905)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7815_6905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3 10.2998L14.5 18.8998L11.4 16.0998L11.3 15.9998C10.8 15.6998 10.1 15.6998 9.70001 16.1998C9.30001 16.6998 9.30001 17.4998 9.80001 17.8998L13.8 21.4998L13.9 21.5998C14.4 21.9998 15.1 21.8998 15.5 21.3998L23.2 11.8998L23.3 11.7998C23.6 11.2998 23.5 10.5998 23 10.1998C22.5 9.69982 21.8 9.79982 21.3 10.2998Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7 12.6C29.3 11.7 28.6 10 28.9 8.3C29.2 7 28.8 5.6 27.8 4.6C26.8 3.6 25.5 3.2 24.1 3.5C22.5 4 20.8 3.3 19.9 1.8C19.1 0.7 17.9 0 16.5 0C15.1 0 13.9 0.7 13.1 1.8C12.2 3.3 10.5 4 8.9 3.6C7.5 3.3 6.2 3.7 5.2 4.7C4.2 5.7 3.8 7 4.1 8.4C4.5 10 3.8 11.7 2.3 12.6C1.2 13.4 0.5 14.6 0.5 16C0.5 17.4 1.2 18.6 2.3 19.4C3.8 20.3 4.5 22 4.1 23.6C3.8 24.9 4.2 26.3 5.2 27.3C6.2 28.3 7.5 28.7 8.9 28.4C10.5 28 12.2 28.8 13.2 30.2C13.9 31.3 15.2 32 16.6 32C18 32 19.2 31.3 20 30.2C20.9 28.8 22.6 28.1 24.3 28.4C25.6 28.7 27 28.3 28 27.3C29 26.3 29.4 25 29.1 23.6C28.8 22 29.5 20.3 30.9 19.3C32 18.6 32.7 17.3 32.7 15.9C32.7 14.5 31.8 13.4 30.7 12.6ZM29.6 17.7C27.5 19 26.4 21.6 26.9 24C27 24.7 26.8 25.4 26.4 25.8C25.9 26.3 25.2 26.5 24.6 26.3C22.2 25.8 19.6 26.8 18.2 28.9C17.8 29.5 17.2 29.8 16.5 29.8C15.8 29.8 15.2 29.5 14.8 28.9C13.7 27.2 11.7 26.1 9.7 26.1C9.3 26.1 8.9 26.1 8.4 26.2C7.7 26.3 7 26.1 6.6 25.7C6.1 25.2 5.9 24.5 6.1 23.9C6.6 21.5 5.6 18.9 3.5 17.5C2.8 17.3 2.5 16.7 2.5 16C2.5 15.3 2.8 14.7 3.4 14.3C5.5 13 6.6 10.4 6.1 8C5.9 7.3 6.1 6.6 6.6 6.1C7.1 5.6 7.8 5.4 8.5 5.6C10.9 6.1 13.5 5.1 14.9 3C15.2 2.3 15.8 2 16.5 2C17.2 2 17.8 2.3 18.2 2.9C19.5 5 22.1 6.1 24.5 5.6C25.2 5.5 25.9 5.7 26.3 6.1C26.7 6.5 27 7.3 26.8 7.9C26.3 10.3 27.3 12.9 29.4 14.3C30 14.7 30.3 15.3 30.3 16C30.3 16.7 30.2 17.3 29.6 17.7Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7815_6905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7815_6905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.904e98fe3c25bdd67e06e3b089af5c1d.svg";
export { ForwardRef as ReactComponent };